// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessage-moduleEmailProfileMessage__AFktx";
var _2 = "EmailProfileMessage-moduleisExpanded__bA847";
export { _1 as "EmailProfileMessage", _2 as "isExpanded" }
